var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton"},[_c('div',{class:[_vm.isMobile ? "skeleton-image-mobile" : "skeleton-image"]}),_c('div',{staticClass:"skeleton-title"}),_c('div',{staticClass:"skeleton-rating"})])}
var staticRenderFns = []

export { render, staticRenderFns }